// extracted by mini-css-extract-plugin
export default {"carousel":"styles_carousel__hD4z1","fadeViewport":"styles_fadeViewport__HOo-r","slide":"styles_slide__3KPWy","active":"styles_active__lC5g+","navBtn":"styles_navBtn__mbCjG"};